import 'core-js/stable';
import 'regenerator-runtime/runtime';
import FormHandler from "./ahx-wcpl-ajax-form.js";
import AddListHandler from "./ahx-wcpl-ajax-lists.js";
import * as WcplAjaxItems from "./ahx-wcpl-ajax-items.js";
import DeleteListHandler from "./ahx-wcpl-ajax-delete-list.js";
import EditListHandler from "./ahx-wcpl-ajax-edit-list.js";
import CreateListFromOrderHandler from "./ahx-wcpl-ajax-create-list-from-order.js";
import AddToListNoSearchHandler from "./ahx-wcpl-ajax-add-to-list-no-search.js";
import AddToListHandler from "./ahx-wcpl-ajax-add-to-list.js";
import CopyListHandler from "./ahx-wcpl-ajax-copy-list.js";
import SearchListHandler from "./ahx-wcpl-search-list-handler.js";

const addListForm = document.getElementById("add_list_form");
const addListHandler = new AddListHandler(addListForm);

const deleteItemForm = document.getElementById("delete_item_form");
const addAllListItemsToCartForm = document.getElementById(
    "add_all_list_items_to_cart_form"
);
const addAllOrderItemsToCartForm = document.getElementById(
    "add_all_order_items_to_cart_form"
);
const addListItemToCartForm = document.querySelectorAll(
    ".add-list-item-to-cart"
);


const searchListHandler = new SearchListHandler();
// searchListHandler.init();

//TODO - Only instantiate these classes based on the page we are on.

const deleteItemFormHandler = new WcplAjaxItems.DeleteItemHandler(
    deleteItemForm
);

if ( addAllListItemsToCartForm ) {

    const addAllListItemsToCartHandler = new WcplAjaxItems.AddAllListItemsToCart(
        addAllListItemsToCartForm
    );

}

if ( addAllOrderItemsToCartForm ) {
    
    const addAllOrderItemsToCartFormHandler =
        new WcplAjaxItems.AddAllOrderItemsToCartHandler(addAllOrderItemsToCartForm);

}

addListItemToCartForm?.forEach((form) => {
    new WcplAjaxItems.AddListItemToCart(form);
});

/**
 * Delete List
 */
const deleteListForm = document.getElementById("delete_list_form");
const deleteFormHandler = new DeleteListHandler(deleteListForm);

/*
 * Edit List
 */
const editListForm = document.getElementById("edit_list_form");
const editListFormHandler = new EditListHandler(editListForm);

/*
* Create List From Order
*/

const createListFromOrderForm = document.getElementById("create_list_from_order_form");
const createListFromOrderHandler = new CreateListFromOrderHandler(createListFromOrderForm);

/**
 * Add to List Shop Category Pages
 */
let addItemFormHandler;
const forms = document.querySelectorAll(".ahx-list-form-no-search");

forms?.forEach((form) => {
    addItemFormHandler = new AddToListNoSearchHandler(form);
});

/**
 * Add to list handler on list pages
 */

const addToListForm = document.getElementById("add_to_list_form");

if (addToListForm) {
    let addItemFormHandler = new AddToListHandler(addToListForm);
}


/*
* Copy List
*/

const copyListForm = document.getElementById("copy_list_form");
const copyListHandler = new CopyListHandler(copyListForm);